export function initTwitter(elementId, accountname) {
    const doesExist = document.querySelector(`#${elementId}`)

    if (doesExist) {
        createBlock()

        const configProfile = {
            'profile': { 'screenName': accountname },
            "maxTweets": 6,
            'showImages': true,
            'dataOnly': true,
            'customCallback': handleTweets,
            'lang': 'nl'
        }

        twitterFetcher.fetch(configProfile)
    }

    function createBlock() {
        const content = doesExist.querySelector('div.content')

        if (content) {
            const h2 = document.createElement('h2')
            h2.innerHTML = 'Connect with us on Twitter'
            h2.style = 'margin-bottom: 2em;'

            const div = document.createElement('div')
            div.classList.add('twitter-block')
            div.id = 'twitter-list-target'

            content.appendChild(h2)
            content.appendChild(div)
        }
    }

    // Creates a div.tweets with div.tweet inside of it.
    function handleTweets(tweets) {
        const content = doesExist.querySelector('div.content')
        if (content) {
            const maxTweets = Math.min(tweets.length, 2)
            const twitterBlock = content.querySelector('div.twitter-block')
            var html = '<div class="tweets">'
            
            for (let i = 0; i < maxTweets; i++) {
                const tweet = tweets[i]
                html += '<div class="tweet">'

                html += '<div class="image">'
                if (tweet.image) {
                    html += '<img src="' + tweet.image + '">'
                }
                html += '</div>'

                if (tweet.author_data.name) {
                    html += '<div class="author">'
                    html += '<p>' 

                    if (tweet.timestamp) {
                        const date = new Date(tweet.timestamp)
                        const month = new Intl.DateTimeFormat('en-GB', { month: 'long' }).format(date)
                        
                        html += `<span class="date">${date.getDay()} ${month}, ${date.getFullYear()}</span>&nbsp;&mdash;&nbsp;`
                    }

                    html += tweet.author_data.name + '&nbsp;<i>' + tweet.author_data.screen_name + '</i>'
                    html += '</p>'
                    html += '</div>'
                }

                if (tweet.tweet) {
                    html += '<div class="text">'
                    html += '<p>' + tweet.tweet + '</p>'
                    html += '</div>'
                }
                
                if (tweet.permalinkURL) {
                    html += '<a class="button" href="' + tweet.permalinkURL + '" target="_blank" rel="noopener noreferrer">Go to Tweet</a>'
                }

                html += '</div>'
            }

            html += '</div>'
            twitterBlock.innerHTML = html
        }
    }
}